import axios from 'axios'
import {
	setBarcodeData
} from '../../../actions/barcodeScanner'
// import { getDetailsPageUrl } from '../../common/productFunctions';
import { showHideLoader } from '../../../actions/index';
/**
 * @param {string} barcode 
 * @param {function} dispatch 
 * @param {*} {
 * 	history
 * } 
 */
export const onScannerDetectedCB = async (barcode, dispatch, {
	history
}) => {
	console.log('barCode --> ',barcode);
	let response;
	dispatch(showHideLoader({
		showLoader: true
	}))
	try {
		response = await fetchProductsByBarcode(barcode);
	} catch(e){
		console.log(e);
	} finally {
		dispatch(showHideLoader({
			showLoader: false
		}))
	}
	let products = response.data.results.data[0] || {};
	products = Object.keys(products).map((key) => products[key]);
	const noOfProducts = products.length;
	//console.log('Products', products, noOfProducts);
	if(noOfProducts > 1){
		dispatch(setBarcodeData({
			scannedBarcode: barcode,
			products,
			failedStatus: false,
			showBarcodeResults: true
		}))
	} else if(noOfProducts){
		// ask virender to send details page url
		// open that product
		// const productData = products[0];
		// const detailsPageUrl = getDetailsPageUrl(productData.variantitemname, productData.variantId, '/');
		setTimeout(() => {
			// history.push(detailsPageUrl);
		})
	} else{
		// set no product found
		dispatch(setBarcodeData({
			scannedBarcode: barcode,
			products: [],
			failedStatus: false,
			showBarcodeResults: true
		}))
	}
}

const fetchProductsByBarcode = (barcode) => {
	return axios
		.get("/ajax.php", {
			params: {
				action: 'barcodeSearch',
				barcode
			}
		})
}

/**
 * @param {function} dispatch 
 */
export const onScannerFailedCB = (dispatch) => {
	console.log('Secondary Scanner Failed Here with Dispatch', dispatch)
	dispatch(setBarcodeData({
		failedStatus: true,
		showBarcodeResults: true
	}))
}